module.exports = __webpack_public_path__ + "img/6E5137_E8CA90_271912_B99C74-256px.ca7b1e18.png";